import { useEffect, useId, useRef, useState } from 'react'

export function Popover({ children, content, label }) {
  const [open, setOpen] = useState(false)
  const contentId = useId()
  const root = useRef(null)

  useEffect(() => {
    if (!open) return undefined

    function close(event) {
      if (event.type === 'keydown' && event.key !== 'Escape') return
      if (
        event.type === 'pointerdown' &&
        root.current?.contains(event.target)
      ) {
        return
      }
      setOpen(false)
    }

    document.addEventListener('keydown', close)
    document.addEventListener('pointerdown', close)
    return () => {
      document.removeEventListener('keydown', close)
      document.removeEventListener('pointerdown', close)
    }
  }, [open])

  return (
    <span
      className='relative inline-flex'
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      ref={root}
    >
      <button
        aria-controls={contentId}
        aria-expanded={open}
        aria-label={label}
        className='inline-flex rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
        onClick={() => setOpen(value => !value)}
        onFocus={() => setOpen(true)}
        type='button'
      >
        {children}
      </button>
      {open && (
        <span
          className='absolute bottom-full left-1/2 z-50 mb-2 w-64 max-w-[calc(100vw-2rem)] -translate-x-1/2 rounded-md bg-foreground px-3 py-2 text-left text-xs font-normal leading-5 text-background shadow-lg'
          id={contentId}
          role='tooltip'
        >
          {content}
        </span>
      )}
    </span>
  )
}
